export const comments_3903060 = {"data":{"data":[],"links":{}}}